// extracted by mini-css-extract-plugin
export default {"collapseHeader":"Exercises_collapseHeader__WHK3I","addBtn":"Exercises_addBtn__vWWh2"};